/**
 * Surfaces that belong to Premium Resource Management: the 211, 238, 221 and
 * 213RR sheets. The flag is a UI existence gate — the lifecycle APIs stay open.
 */

import { toBaseFormId } from './formFamily';

export const PREMIUM_RESOURCE_WIDGETS = [
  'checkInList',
  'demobTrackingTable',
  'demobilizationCheckOut',
  'resourceRequestForm',
] as const;

export type PremiumResourceWidget = (typeof PREMIUM_RESOURCE_WIDGETS)[number];

const PREMIUM_WIDGET_SET: ReadonlySet<string> = new Set(PREMIUM_RESOURCE_WIDGETS);

const PREMIUM_FORM_BASE_IDS: ReadonlySet<string> = new Set([
  'ICS_211',
  'ICS_238',
  'ICS_221',
  'ICS_213RR',
]);

export const isPremiumResourceWidget = (widgetName: string): boolean =>
  PREMIUM_WIDGET_SET.has(widgetName);

/**
 * Accepts a suffixed Coast Guard name (`ICS_211_CG`) or a bare base id.
 */
export const isPremiumResourceForm = (formname: string): boolean =>
  PREMIUM_FORM_BASE_IDS.has(toBaseFormId(formname));
